import React, { useEffect, useState } from "react";
import logo from "../image/logo-divine.png";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import axios from "../axiosInstance";
import instagram from "../image/instagram.png";
import twitter from "../image/twitter.png";
import fb from "../image/fb.png";
import x from "../image/x.png";
import whatsapp from "../image/wp.png";

const Header = () => {
  const [websiteData, setWebsiteData] = useState();
  const [builderData, setBuilderData] = useState();
  const [opacity, setOpacity] = useState(0);
  const [visibility, setVisibility] = useState("hidden");

  const navigate = useNavigate();
  useEffect(() => {
    axios
      .get(`api/users/get-settings`)
      .then((resp) => {
        setWebsiteData(resp.data.result.settingData);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`api/users/get-home-builder-list`)
      .then((resp) => {
        setBuilderData(resp.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
    $(".sidebar-panel").css("display", "none");
  }, []);

  function handleSidebar() {
    $(".sidebar-panel").toggle("slow");
  }
  function handleClose() {
    $(".sidebar-panel").toggle("slow");
  }

  function changeCss() {
    setOpacity(1);
    setVisibility("visible");
    $(".my-header-dropdown").css("color", "white");
  }
  function leaveChangeCss() {
    setOpacity(0);
    setVisibility("hidden");
    $(".my-header-dropdown").css("color", "black");
  }

  $(window).scroll(function () {
    var sticky = $(".sticky-top-header"),
      scroll = $(window).scrollTop();

    if (scroll >= 100) {
      sticky.addClass("fixed-header-top");
      $(".navbar-hide").hide();
    } else {
      sticky.removeClass("fixed-header-top");
      $(".navbar-hide").show();
    }
  });

  const [showChat, setShowChat] = useState(false);
  return (
    <>
      <header id="header-container" className="sticky-top-header">
        <div style={{ backgroundColor: "#f5f5f5", height: "40px" }}>
          <div className="container">
            <ul className="netsocials top-header-social">
              <li className="for-desktop">
                <a
                  href="#"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "500",
                    color: "#C07F00",
                  }}
                  title="Divine Bricks Favourite Properties"
                >
                  <i
                    className="fa fa-star"
                    aria-hidden="true"
                    style={{ border: "none" }}
                  ></i>
                  Favourite Properties
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  title="Divine Bricks Facebook"
                  href={websiteData?.fb_link}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 48 48"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_3508_5)">
                      <path
                        d="M48 24C48 10.7453 37.2547 0 24 0C10.7453 0 0 10.7453 0 24C0 35.255 7.74912 44.6995 18.2026 47.2934V31.3344H13.2538V24H18.2026V20.8397C18.2026 12.671 21.8995 8.8848 29.9194 8.8848C31.44 8.8848 34.0637 9.18336 35.137 9.48096V16.129C34.5706 16.0694 33.5866 16.0397 32.3645 16.0397C28.4294 16.0397 26.9088 17.5306 26.9088 21.4061V24H34.7482L33.4013 31.3344H26.9088V47.8243C38.7926 46.3891 48.001 36.2707 48.001 24H48Z"
                        fill="#0866FF"
                      />
                      <path
                        d="M33.4003 31.3344L34.7472 24H26.9078V21.4061C26.9078 17.5306 28.4285 16.0397 32.3635 16.0397C33.5856 16.0397 34.5696 16.0694 35.136 16.129V9.48096C34.0627 9.1824 31.439 8.8848 29.9184 8.8848C21.8986 8.8848 18.2016 12.671 18.2016 20.8397V24H13.2528V31.3344H18.2016V47.2934C20.0582 47.7542 22.0003 48 23.999 48C24.983 48 25.9536 47.9395 26.9069 47.8243V31.3344H33.3994H33.4003Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3508_5">
                        <rect width="48" height="48" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  title="Divine Bricks Twitter"
                  href={websiteData?.tw_link}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 48 48"
                    fill="none"
                  >
                    <path
                      d="M36.6526 3.8078H43.3995L28.6594 20.6548L46 43.5797H32.4225L21.7881 29.6759L9.61989 43.5797H2.86886L18.6349 25.56L2 3.8078H15.9222L25.5348 16.5165L36.6526 3.8078ZM34.2846 39.5414H38.0232L13.8908 7.63406H9.87892L34.2846 39.5414Z"
                      fill="black"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  title="Divine Bricks Instagram"
                  href={websiteData?.insta_link}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <path
                      d="M10.7527 0.602722C6.56874 0.602722 5.3451 0.60703 5.10724 0.626724C4.24863 0.697961 3.71435 0.832895 3.13228 1.12215C2.6837 1.34448 2.32993 1.60219 1.98078 1.96345C1.34491 2.62228 0.959539 3.43281 0.820033 4.39627C0.752207 4.86401 0.732476 4.9594 0.728468 7.34852C0.726927 8.1449 0.728468 9.19299 0.728468 10.5988C0.728468 14.7715 0.733093 15.9916 0.753132 16.2285C0.8225 17.0624 0.953527 17.5871 1.231 18.161C1.76127 19.2595 2.77404 20.0842 3.96715 20.3919C4.38027 20.4981 4.83656 20.5566 5.42233 20.5843C5.67051 20.595 8.2001 20.6027 10.7312 20.6027C13.2624 20.6027 15.7935 20.5996 16.0355 20.5873C16.7138 20.5555 17.1076 20.5027 17.5431 20.3904C18.1347 20.239 18.6861 19.9605 19.1587 19.5743C19.6312 19.1882 20.0137 18.7038 20.2793 18.1548C20.5514 17.5948 20.6893 17.0501 20.7517 16.2597C20.7653 16.0874 20.771 13.34 20.771 10.5962C20.771 7.85195 20.7648 5.10957 20.7513 4.93724C20.6881 4.1341 20.5501 3.59405 20.2693 3.02323C20.0388 2.55596 19.7829 2.20701 19.4114 1.85021C18.7486 1.21816 17.9377 0.833511 16.9714 0.694422C16.5032 0.626878 16.41 0.606876 14.0145 0.602722H10.7527Z"
                      fill="url(#paint0_radial_77_597)"
                    />
                    <path
                      d="M10.7527 0.602722C6.56874 0.602722 5.3451 0.60703 5.10724 0.626724C4.24863 0.697961 3.71435 0.832895 3.13228 1.12215C2.6837 1.34448 2.32993 1.60219 1.98078 1.96345C1.34491 2.62228 0.959539 3.43281 0.820033 4.39627C0.752207 4.86401 0.732476 4.9594 0.728468 7.34852C0.726927 8.1449 0.728468 9.19299 0.728468 10.5988C0.728468 14.7715 0.733093 15.9916 0.753132 16.2285C0.8225 17.0624 0.953527 17.5871 1.231 18.161C1.76127 19.2595 2.77404 20.0842 3.96715 20.3919C4.38027 20.4981 4.83656 20.5566 5.42233 20.5843C5.67051 20.595 8.2001 20.6027 10.7312 20.6027C13.2624 20.6027 15.7935 20.5996 16.0355 20.5873C16.7138 20.5555 17.1076 20.5027 17.5431 20.3904C18.1347 20.239 18.6861 19.9605 19.1587 19.5743C19.6312 19.1882 20.0137 18.7038 20.2793 18.1548C20.5514 17.5948 20.6893 17.0501 20.7517 16.2597C20.7653 16.0874 20.771 13.34 20.771 10.5962C20.771 7.85195 20.7648 5.10957 20.7513 4.93724C20.6881 4.1341 20.5501 3.59405 20.2693 3.02323C20.0388 2.55596 19.7829 2.20701 19.4114 1.85021C18.7486 1.21816 17.9377 0.833511 16.9714 0.694422C16.5032 0.626878 16.41 0.606876 14.0145 0.602722H10.7527Z"
                      fill="url(#paint1_radial_77_597)"
                    />
                    <path
                      d="M10.748 3.22327C8.73984 3.22327 8.48782 3.23203 7.6991 3.26786C6.91192 3.30384 6.3746 3.42822 5.90445 3.61073C5.41812 3.79924 5.00558 4.0514 4.59458 4.46178C4.18328 4.872 3.93064 5.28376 3.74116 5.76902C3.55785 6.23844 3.43307 6.7749 3.39764 7.56029C3.36251 8.34752 3.35327 8.59922 3.35327 10.6036C3.35327 12.608 3.36221 12.8587 3.39795 13.646C3.43415 14.4317 3.55877 14.968 3.74147 15.4372C3.93049 15.9227 4.18312 16.3344 4.59428 16.7446C5.00512 17.1552 5.41766 17.408 5.90368 17.5965C6.37414 17.779 6.91161 17.9034 7.69863 17.9393C8.48736 17.9752 8.73922 17.9839 10.7472 17.9839C12.7555 17.9839 13.0068 17.9752 13.7955 17.9393C14.5827 17.9034 15.1206 17.779 15.5911 17.5965C16.0773 17.408 16.4892 17.1552 16.9 16.7446C17.3113 16.3344 17.564 15.9227 17.7534 15.4374C17.9352 14.968 18.06 14.4315 18.097 13.6461C18.1324 12.8589 18.1416 12.608 18.1416 10.6036C18.1416 8.59922 18.1324 8.34767 18.097 7.56044C18.06 6.77474 17.9352 6.23844 17.7534 5.76917C17.564 5.28376 17.3113 4.872 16.9 4.46178C16.4887 4.05125 16.0774 3.79909 15.5906 3.61073C15.1192 3.42822 14.5816 3.30384 13.7944 3.26786C13.0057 3.23203 12.7546 3.22327 10.7458 3.22327H10.748ZM10.0847 4.55326C10.2815 4.55296 10.5012 4.55326 10.748 4.55326C12.7223 4.55326 12.9563 4.56034 13.7359 4.5957C14.4568 4.6286 14.8481 4.74884 15.1088 4.84986C15.4538 4.98363 15.6998 5.14354 15.9585 5.40185C16.2173 5.66016 16.3775 5.90617 16.5118 6.25058C16.613 6.51043 16.7337 6.90098 16.7665 7.62056C16.8019 8.39857 16.8096 8.63228 16.8096 10.6019C16.8096 12.5715 16.8019 12.8052 16.7665 13.5832C16.7335 14.3028 16.613 14.6934 16.5118 14.9532C16.3778 15.2976 16.2173 15.5429 15.9585 15.801C15.6997 16.0593 15.454 16.2193 15.1088 16.353C14.8484 16.4545 14.4568 16.5744 13.7359 16.6073C12.9564 16.6427 12.7223 16.6504 10.748 16.6504C8.77358 16.6504 8.53958 16.6427 7.7601 16.6073C7.03916 16.5741 6.64788 16.4539 6.38708 16.3529C6.04201 16.2191 5.79554 16.0592 5.53674 15.8009C5.27794 15.5426 5.11773 15.2972 4.9834 14.9526C4.88219 14.6928 4.76157 14.3022 4.72876 13.5826C4.69333 12.8046 4.68624 12.5709 4.68624 10.6001C4.68624 8.6292 4.69333 8.39672 4.72876 7.61871C4.76172 6.89913 4.88219 6.50859 4.9834 6.24843C5.11742 5.90402 5.27794 5.65801 5.53674 5.39969C5.79554 5.14138 6.04201 4.98148 6.38708 4.8474C6.64772 4.74592 7.03916 4.62599 7.7601 4.59293C8.44222 4.56218 8.70656 4.55296 10.0847 4.55142V4.55326ZM14.695 5.77871C14.5195 5.77871 14.3479 5.83065 14.202 5.92798C14.0561 6.02531 13.9423 6.16365 13.8752 6.3255C13.808 6.48734 13.7905 6.66543 13.8248 6.83724C13.859 7.00904 13.9436 7.16685 14.0677 7.2907C14.1918 7.41454 14.3499 7.49887 14.5221 7.533C14.6942 7.56714 14.8726 7.54956 15.0348 7.48248C15.1969 7.4154 15.3355 7.30184 15.4329 7.15616C15.5304 7.01047 15.5824 6.83921 15.5823 6.66404C15.5823 6.17509 15.1849 5.7784 14.695 5.7784V5.77871ZM10.748 6.81349C8.65095 6.81349 6.95074 8.5105 6.95074 10.6036C6.95074 12.6967 8.65095 14.3929 10.748 14.3929C12.845 14.3929 14.5448 12.6967 14.5448 10.6036C14.5448 8.5105 12.845 6.81349 10.748 6.81349ZM10.748 8.14349C12.1092 8.14349 13.2128 9.24485 13.2128 10.6036C13.2128 11.9622 12.1092 13.0637 10.748 13.0637C9.38668 13.0637 8.28324 11.9622 8.28324 10.6036C8.28324 9.24485 9.38668 8.14349 10.748 8.14349Z"
                      fill="white"
                    />
                    <defs>
                      <radialGradient
                        id="paint0_radial_77_597"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(6.05179 22.1431) rotate(-90) scale(19.8215 18.4754)"
                      >
                        <stop stopColor="#FFDD55" />
                        <stop offset="0.1" stopColor="#FFDD55" />
                        <stop offset="0.5" stopColor="#FF543E" />
                        <stop offset="1" stopColor="#C837AB" />
                      </radialGradient>
                      <radialGradient
                        id="paint1_radial_77_597"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(-2.62956 2.04349) rotate(78.6568) scale(8.86102 36.5984)"
                      >
                        <stop stopColor="#3771C8" />
                        <stop offset="0.128" stopColor="#3771C8" />
                        <stop offset="1" stopColor="#6600FF" stop-opacity="0" />
                      </radialGradient>
                    </defs>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  title="Divine Bricks Youtube Channel"
                  href={websiteData?.youtube_link}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 48 48"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_3508_2)">
                      <path
                        d="M47.044 12.3709C46.7726 11.3497 46.2378 10.4178 45.493 9.66822C44.7483 8.91869 43.8197 8.37791 42.8003 8.1C39.0476 7.09091 24.0476 7.09091 24.0476 7.09091C24.0476 7.09091 9.04761 7.09091 5.29488 8.1C4.27547 8.37791 3.34693 8.91869 2.60218 9.66822C1.85744 10.4178 1.32262 11.3497 1.05124 12.3709C0.0476075 16.14 0.0476074 24 0.0476074 24C0.0476074 24 0.0476075 31.86 1.05124 35.6291C1.32262 36.6503 1.85744 37.5822 2.60218 38.3318C3.34693 39.0813 4.27547 39.6221 5.29488 39.9C9.04761 40.9091 24.0476 40.9091 24.0476 40.9091C24.0476 40.9091 39.0476 40.9091 42.8003 39.9C43.8197 39.6221 44.7483 39.0813 45.493 38.3318C46.2378 37.5822 46.7726 36.6503 47.044 35.6291C48.0476 31.86 48.0476 24 48.0476 24C48.0476 24 48.0476 16.14 47.044 12.3709Z"
                        fill="#FF0302"
                      />
                      <path
                        d="M19.1385 31.1373V16.8628L31.684 24.0001L19.1385 31.1373Z"
                        fill="#FEFEFE"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3508_2">
                        <rect width="48" height="48" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="fixed-whatsapp">
          <a
            target="_blank"
            title="Divine Bricks On Whatsapp"
            href={websiteData?.whats_link}
          >
            <img
              src={whatsapp}
              alt="divine-bricks-whatsapp-group"
              title="Divine Bricks On Whatsapp"
            />
          </a>
        </div>
        <div id="header">
          <div className="container container-header">
            <div className="left-side">
              <div id="logo">
                <Link to="/" title="Divine Bricks">
                  <img
                    src={logo}
                    alt="divine-bricks-logo"
                    title="Divine Bricks---111"
                  />
                </Link>
              </div>
              <div className="mmenu-trigger" onClick={handleSidebar}>
                <button className="hamburger hamburger--collapse" type="button">
                  <span className="hamburger-box">
                    <span className="hamburger-inner"></span>
                  </span>
                </button>
              </div>
              <nav id="navigation" className="style-1 for-desktop">
                <ul id="responsive">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about-us">About Us</Link>
                  </li>
                  <li>
                    <div className="dropdown">
                      <span
                        className="dropdown-toggle my-header-dropdown"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        onMouseEnter={changeCss}
                        onMouseLeave={leaveChangeCss}
                        style={{ border: "none", background: "transparent" }}
                      >
                        Builders
                      </span>
                      <ul
                        className="dropdown-menu"
                        style={{
                          opacity: opacity,
                          visibility: visibility,
                          display: "block",
                        }}
                        onMouseEnter={changeCss}
                        onMouseLeave={leaveChangeCss}
                      >
                        {builderData?.map((data) => {
                          return (
                            <li>
                              <Link
                                className="dropdown-item"
                                to={"/property-listing?id=" + data.id}
                              >
                                {data.name}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </li>
                  <li>
                    <Link to="/investments">Investments</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                  {/* <li><Link to='/'>Blogs</Link></li> */}
                  {/* <li className="new-feature-li" style={{ padding: '6px 16px' }}><button type="button" className="btn btn-warning new-feature" data-toggle="tooltip" data-placement="bottom" title="Upcoming Feature!" style={{ background: 'linear-gradient(90deg, rgba(192,127,0,1) 0%, rgba(203,170,92,1) 56%)', color: 'white' }} onClick={() => navigate('/start-listing')}>Dream Guest<span style={{ background: 'white', color: 'black', borderRadius: '4px', padding: '0 5px', marginLeft: '10px' }}>New</span></button></li> */}
                  <li
                    className="new-feature-li"
                    style={{ padding: "6px 16px" }}
                  >
                    <button
                      type="button"
                      className="btn btn-warning new-feature"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Sell Your Property"
                      style={{
                        background:
                          "linear-gradient(90deg, rgba(192,127,0,1) 0%, rgba(203,170,92,1) 56%)",
                        color: "white",
                      }}
                      onClick={() => navigate("/seller-register")}
                    >
                      Sell Your Property
                      <span
                        style={{
                          background: "white",
                          color: "black",
                          borderRadius: "4px",
                          padding: "0 5px",
                          marginLeft: "10px",
                        }}
                      >
                        New
                      </span>
                    </button>
                  </li>
                  {/* <li className="li-img" onClick={() => setShowChat(!showChat)}>
                    <img
                      style={{
                        width: "50px",
                        cursor: "pointer",
                        marginRight: "40px",
                      }}
                      src="data:image/png;base64,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"
                    />
                  </li> */}
                  {/* <li className="login-credentials" style={{ color: 'black', fontWeight: '600', fontSize: '19px', marginRight: '20px' }}><Link to='/seller-login'>Login</Link></li> */}
                  {/* <li className="login-credentials" style={{ color: 'black', fontWeight: '600', fontSize: '19px' }}><Link to='/seller-register'>Register</Link></li> */}
                  {/* <li><button style={{ width: 'max-content', padding: '2px 20px', backgroundColor: '#687389', color: 'white', border: 'none', borderRadius: '4px', fontSize: '20px' }}>Login</button></li> */}
                  {/* <li><button style={{ padding: '2px 20px', backgroundColor: '#325846', color: 'white', border: 'none', borderRadius: '4px', fontSize: '20px' }}>Register</button></li> */}
                  {/* <li className="d-none d-xl-none d-block d-lg-block mt-5 pb-4 ml-5 border-bottom-0"><a href="add-property.html" className="button border btn-lg btn-block text-center">Add Listing<i className="fas fa-laptop-house ml-2"></i></a></li> */}
                </ul>
              </nav>
              <nav id="navigation" className="style-1 for-mobile sidebar-panel">
                <div style={{ padding: "20px" }}>
                  <img src={logo} style={{ width: "100px" }} />
                  <button
                    style={{
                      float: "right",
                      border: "none",
                      width: "30px",
                      height: "30px",
                      borderRadius: "4px",
                    }}
                    onClick={handleClose}
                  >
                    X
                  </button>
                </div>
                <ul
                  id="responsive"
                  style={{
                    paddingBottom: "32px",
                    display: "grid",
                  }}
                >
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <div className="dropdown">
                      <span
                        className="dropdown-toggle my-header-dropdown"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        onMouseEnter={changeCss}
                        onMouseLeave={leaveChangeCss}
                        style={{ border: "none", background: "transparent" }}
                      >
                        Builders
                      </span>
                      <ul
                        className="dropdown-menu"
                        style={{
                          opacity: opacity,
                          visibility: visibility,
                          display: "block",
                        }}
                        onMouseEnter={changeCss}
                        onMouseLeave={leaveChangeCss}
                      >
                        {builderData?.map((data) => {
                          return (
                            <li>
                              <Link
                                className="dropdown-item"
                                to={"/property-listing?id=" + data.id}
                              >
                                {data.name}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </li>
                  <li>
                    <Link to="/investments">Investments</Link>
                  </li>
                  <li>
                    <Link to="/about-us">About Us</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact</Link>
                  </li>
                  {/* <li><Link to='/'>Blogs</Link></li> */}
                  {/* <li className="new-feature-li" style={{ padding: '6px 16px' }}><button type="button" className="btn btn-warning new-feature" data-toggle="tooltip" data-placement="bottom" title="Upcoming Feature!" style={{ color: 'white' }} onClick={() => navigate('/start-listing')}>Dream Guest<span style={{ background: 'white', color: 'black', borderRadius: '4px', padding: '0 5px', marginLeft: '10px' }}>New</span></button></li> */}
                  <li
                    className="new-feature-li"
                    style={{ padding: "6px 16px" }}
                  >
                    <button
                      type="button"
                      className="btn btn-warning new-feature"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Sell Your Property"
                      style={{
                        background:
                          "linear-gradient(90deg, rgba(192,127,0,1) 0%, rgba(203,170,92,1) 56%)",
                        color: "white",
                      }}
                      onClick={() => navigate("/seller-register")}
                    >
                      Sell Your Property
                      <span
                        style={{
                          background: "white",
                          color: "black",
                          borderRadius: "4px",
                          padding: "0 5px",
                          marginLeft: "10px",
                        }}
                      >
                        New
                      </span>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
            {showChat ? (
              <div className="chat-support">
                <div className="chat-header">
                  <img
                    style={{
                      width: "32px",
                      cursor: "pointer",
                      marginRight: "10px",
                    }}
                    alt="chat-with-divine-bricks"
                    title="Divine Bricks Customer Support"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAkFBMVEX///8dHRsAAAAbGxkfHx38/Pz+/vwZGRfCwsAeHhsXFxX5+fn8/PoDAwCmpqadnZsSEg98fHzw8PANDQrk5ORsbGrt7e2FhYMvLy0qKii2trTc3NqRkY/Hx8UyMjBISEhcXFo+PjzV1dV2dnZTU1HR0c+VlZNkZGKysrCjo6NYWFgmJia8vLpMTEo7OzkQEBGN/24BAAATsUlEQVR4nO1dCWOquhKGJBDZFNncd61r2///714mG2jBUy1qex/f7e059VCYj0kySyaJYTRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGvy/wbryU4NfCUvoievKS5aT3Vt3u15Mp/3pdLHedt92k2XiyQvVxX8IlgVfAC/bdFbrDxwgFMSuSyl8uTH8iD/Wq84m8+SvqN/4I7C4uNlpPHMZFxcTQkxiMsi/wBehISOKZ+NTxn/lxSLfBgta5m4+CIKQmkAJY0cRZBSxyT8ygS0OUTCY7xLv1TLfCGuYHlFIGQVgAoDvJP+rAMbwr0yZ6JgO/4ASLdk4jWU3QKH5FYQU/zgHU2V3ZBu2bVnWr+2RcmzZpCRQ6rqkJ1ppCUmMiYNIuvHtF5O4Cg/e/XDO1AcdrERRjtShU6pe9hWi+RDe1G/tlEyy1lo1zxIWQoNSi1+A+VeI1i3v1zI0khR9clmJKY1DsRm6IZhBBIYxdPFFKyamHGTNT5QmryZyAT4wsP+jHopzeQVR6F8mBWZ0sU67vfH4bTzuddP1wgSmYEq4rWRXOfKdEDNGvYi7Ob9kxBH0DKM1Q6ZugGDRGTkMhoD2573hMkkiT0psWV6UJJthb96nzKQwelh6AaIpOyaatfidrd/hB4CLZkRd5IL91vYA9ML8meNqt4zUheffGKLNbnVE7Dd5w1Y6ZHcJUTf6NY4cJzhZIOmiCCmBaRjMehNPyXgpq3K2LW/SmwWhqd8O5lwxWkx+i0MOBNsoJOLt646IUNqK9AXG1fgwaqUI6VaKRQMIUfv1/Jj6PMs2oi1S4z0fX6B5zvbRv3+/gGg/Q58O65FYd0gTbSPDt7xXtlXhYCXv8ZllYPqb7aIb3z/rybuZ0GNuR+L3xHitE+cBjckgzGUiBFPG73aReBzMONKiHcXxYPJqF8cyTqwLqu4HxiLutz0t8y03Anjtflzw9whr7qfXdkbL2H1ibs+kRCFajVh8cLu15tezXxyt4I2J21HWo/Hn7lX9EEZI2+ggNQDyoFZY6vwSBT/ZnMbprO9yry3sz9LxaVMIeosUhOcgPCI+3nTYc15g+sUA0A6o0h77Fsar7Gvw42Wt7mEaIhSHQtnsexgzntN5t5V97WJ+tgrc3DsyadB+yXDD7fw+cKUgMECEZMgbqL4Evi33hwAFIcFEB4im8A0cJ45RcNgv9bUC7BZDAskP5R65aG+8wGTAux8iSnInJpgll00pax9cFEpvTnqeWHitDtclcUPkHtpZ8Ze4AZoFR6pcHELRUD7xmWBibKDvuTL1QlAKJr5IMRt/sGCKKUxYAO12iu8YAmJo484n+ngrcoR7RCmSrRRTSFptnqpDeMmWbY9CV5LDTCPorXiBbxvLLkJOaaj7BcRBqLs0bL9I4g3GG2VoaTyybZ1gfgZFz7CjhavkJ5SgvVXI7HpGNB4EuTP9D4JwVTAYRzwNIjl41h7lZgjTRWQb3rP0yMM2P0Wyo0Dkw+2yCv7Yt/aUx1LlWbUvDPmVLpq283gJ2skJ8ciYX+Ki1HtiuAhKekN6kGFdapi7VkyG0Rb44Tyo/RdF8ZpctB3pdggO4RCrV8TuhcbPi/nhOUtEqE61sKHO85RsTLBjLNPaX5I1FQRV0gMdh+oZBtxyqIYbStlQtmSx5HMo+radTF0pHrzdnSRnA6IVKkuzfRNoFdkFm7pDXLv8VbrT5FkjDZOgi+TbF80np26MZsH3xpdSbYJVHXEnTWKMZBIH2HefQo8zPCGlQILRylf9gxGcDGI9PNzD0CRhf6IeBK7ailHUEfHpWQyzvqkHGbwwbPXGmbuFwYQQeidDGH+JS4dah+zPBVU6xLifVclUM8ZIvXMTH0d2bsS4br89hJbokH9hpStuO0ZHHWXgvEM8EsxbC7Wdo0g2KRhjjD26m1sR2GSudj5DM0GqwTDnfvPosYan99Y5w7inh1GfaZD5kF+mnG4nyBo506IvH+nbPZlJZz5guH50hpHntpFWVPihEmqMYCuuRYNiIiBuGXr4ij5C7R+ilvFghpYVrWFWXiQOw4mSw7dHR4rv74FFwD3c40gS8X1jIlJd8Fh3HT3Ws2E3Bz9DWrygy1Qn37Q/C01djvBDgnx2f6Z16NtdMYJBkMn8p5oZnjd79riFiplM7Mp6GMvzbBbP1dNGFU2U+nKQZi6vq7u3u/AvxPs5wSJs4xSIJzGnNNjLNCeTZB/XMMYUgUm8NxRDYx+oz53gdClgrSr1/YO25uHa0/VMCaK1qlDkLhJdV+W9h6qOwz3U20ovb7ZBKjVqopa+JprHhNY0kkqwqDqeR1pFJ9UJmJu4+YeMt2K5axewVa2RhO+ere7fRj9wRivAtIjaKiS0vZm0GNiMt0WBdsv7qfmMQdKN0RliR/W3oKWGczu5nJSviyRV2TvbaPGeyOwFIRcihd0EinDuYWjbnQHikXoB6unhwtZP7wU160/CQb1clkVu9s/EYc120LmPoQGpGJMHbWf8ZLDW1nZphB5DEJ4yEo9gTm9b9MS8Ok4IxGdTUXofwRUSrn5Rfu1yT3X+3l6hmi2FAiYq6GV+fTYtTiBoefg0gYlW91BsI1POXH9to8zl1rmGEbk7HvwH2HhKRooh6wuFwrhchyLjyJrUbWBvJEK4avzHPC2kWmkafC9peAdDNp6lQh4Pkl9MWeWNBRpqdJvZYNd2UJUBgETaQE8jRJBJeRBD7JhIRi/sdQ4wLn+V0NRQ51YlshCi2sYRSF5Kd2OP6nC3SwGFUmgvn2NBaqFKHjYwsKDjJoJG8lmtGWK6G+VtRAe3loii8kkHPeGzcasaFdOtE36Z+foHNpDTrhDcobNIziAyU1FSSlobQcgSj1T5VzajVToEB+jSmbsKNnK1UPnNTD6I9/R1verr6gE8Syqnd83wolY1n1sZ8jS+um7hXrmuDoQzLdYQlVatSplqZMjCCpm3tPks6YOBtW+dXYuy62SI3YWnGLbRwynq8jbbW7jVT6u1lQYrnUNZPcjpLiBWHpnvX3tarQy1i2R7fffnDPHVuSri9nWNQvuaUHX2wzxVksSVV4mqi8tWVfaZKQu8K0ADPVtxepIOMdV9v3Vt/CYlMxhlyxQK9U+lt8llX14JtetkSPMpoM41m4LLlh2UfFa1PEEz1C5n1K+OYupkGH7oWZNuUHkVTNswnJtLDBmI+FwRvNbt2oisI33DvmJ962QYH3Q9+jaseP0sskOL8W7XWQcq5GEt7NPstoftLlapQdNxaLzu7HbjRaXzR/DnVjyOSXWo7ve1Mtyq67xDWNGDiPs55rnAaEdDNVYGB9GBN3OVFXBCuuOBXfQWV4zKBIcHT0m1fQ7DYKWuyxaVWVJw7ES53cQVnYdwSXnRpjeXddPUnchqcShKqGDozjIl1aq6V9TJMJ+JTaZV/QfMtFrl+ybr3AcqvvGN0UD8ItSK8c88219V6Qd/JEqq8RWp6mSoS9hG/QqGJJ7k9TXJkV8Vp+oj3zZSTgcf1QonyzYmYVUz7WuGb09iqEfv0YCWF+fRqZfHo17KZc8rKSw14x+mXv6ZNy03BcQdqHTUNev0IIbHClsdLvKbWUY3BqOH8jl4iwXYIHvcPau6qDAF+KUMK1I57odSjsV16JgOOROhletQcfQ+yhli8kqG/QqGvORVMLSM7INnH3LDbRgiNUDoR5bP6G4qXDKM+69jmFR0neJ4C/PiJi/XnubrhCJeF0f4nLX6bFxlCWg+lj6dYca6TnkGE6tCG99OHDkfF6xknjwPK7GZGLIyeIIqmoNJF9oePp2ht65K8Dnm4CRcrZEaQIgJS0O5Bns68+kuRoJ1a1D1OOyutU/zdIbMi6rO0aJ0uNm0VoFy7KCMsd+eLCftfu6EwiKb1mYzTFFlpQpRXuJLGHYr4kM+6RgjSuPY1KKDZUExjaE5StUza4rDwKViJVDFvfIJqBcwvJJoBxZUrJVUe0VgEcvD+mAVbzgwFUGogytnd/IC1pcwvJpVrQtK9lcwtJPHM8QmSl7I0Ht4LpExPHpaqucz9NPw0RlhHKtJ+pcw5LOHjwXMIL6OoW9sHq9DXRdcc3w4+Z4Ovemj557cqZdLdS3Gn1SQ+ZEOr2dO6kHQNXId1pmn+Z4Or15XD9DGzhley7VN8lDzWwxH32NoZxVxa11wP/LSJNtYVzLEqnzqm4BJ88pChZwhvLMO+uYyw9sBFUP8YVo3la+T4Fl2S20bJDV7lRVDBa/NguLZeurXy+U2oYxWS54NqiuGesYtrdTikldVkQBDlSlkX3O3opDn5wRNSudFsZflc8Awn8VduxuL23pVcYMs4lEcNzF5VOUeiw03Rbkr5g8h8uzdRs8StdVBhQ6HZ3fz5/HDdBjP/aJUFXPAxAze71mwb2WMIizTxjlMykI6yM4X77Z5WLWCg4o1zradqqEUVl5IiZh8jGDmX4r/HYZWlKIQn8+9wJoOtUpAPdhP4we10jAtCmR7H4XUnipspzgM0si/WYGGqHicrGF7tQLYj2/5imsO3x49yCSSeHQmeKLdfBLm8qD1xLhvHY0lVlLset0i3pLLuz2u9ItXQBawUwyJu11JeXo7sSrjrjLoqs3ELpZW8RrsRxB0ISNefFIXqZoNMjoX6B5638d1l/9eOOCRGoUNCCw+H8vpkXD2pEXdmmG3doZMV59do7D8nhteVamfxxvPYpheKxy6k2J8KG4Twf3IQO79Qm6LlOpgeCjbcPaHDI+JkS+h5o01xGJ2ivCp4+fq8L1+hrCXiJUPatBIkVz7QcLts3fjsWuOEcGtaJ+NkLavKhkw7GazM56qQ5gNrHVJCSzn6BjFYQZqG5IBFezZv2ZPpceQVIRtd4JAHfn5bjvFNBsRS9afilGty4IIZo6hd+5X+MWkXrB7chs1YJOFOsGctctNve1CyRSd8mD3qRxbdZhDPqfoEod+ti82LmNcbaZCNc96VvHwJJzqcmlYtBe7k/MGKtbm7HSZPkYv2Cm6qujuZrAuuB59iRPYB9FCjWX5RM0zsa8lyIc9IdyeZ1vWGUf+0zjQT4gnTx9JjZpCC2Kiwcmw7UsNQlSB9M5t4ezygsfDtrtVFRnfg8zLxm6vTHbmzfjSs+f+TOv5KrTt9AfWgg0gDt8eKphv/DI7B1thygJVQsElff5WprZ/f2jBlce8tBgdWrZRevCDb2QDVXN06xq8mmB7i5+4NEzsGKcTsVC09PZp3gni9AXDDCwNusaQXsv5YwcHKO5t+K6PVjnHnV4Mz2KOZdVVD0VUaKRQE4R5FAf7lroBousPJE8HgH/hpUIU/oSqoRChabd6Ezbe4yZuvh39zcuZa0IUSx3yMzj4gmsmvhsjsugOkyybjGeDOEChy1wWsY+wiV3YV3gw600y6H2VSrGMaED12thwdts+73XB9vSRD2LdFhxwhILDuDWSUhpGNtmNt7PBp9ys43Pwvh23J4VjnsrTlp7hbQvzPsFNU/X1wffztUFMGtaxpvNxK/qybbnlRVGWjEajJIsiLydW3assy1shondSuEwQPw22ncRy7yimO/Q+niRl0ySXwlllH15e8ia35uBt9D160TlCbHRbzhActPKRdjb1vWXLsDuFhb8wB/oaFUJvsbLdatVZ1n2yWCfOJ9BJ0H7ePsIXgFVLlmg/Vm0eFfhmncLGnjDJ6907AfNTWIbcFN6qjyDctldsopAifVEbFdKI/HutjWiV7+3HRpl+dpYg/p2QKv6njGLX0nc9GwrOUf+3nXFVie+oAPbS3uSeDLh7aPPSw2ZugfSbr3ZY2/Y7fCdUtSUVpqdnZw9/AubYRNeNip/M+dlRekP0kIWOf0WH2a6XHg7zbudaHLsfxLhQcIbRCXbc/bWn6QlwY+K3oLAjdqkLB5T0dJWW8lAtPgGzeUd6yTM/le54U1XlqwBrmZN5GOqzBIiJpp2Lhgc/ZT2Tr55x5CBDXbz55SZCgIk4NGNxTAkRYRZx0Dwraoe5RdmYBlRuyS8owg7tv+V8ueuw2gGWx6+IMYT956DZqEDRSnoDJPbQzzdh38KpFn+hlcLMBhZLoVTCxXQcHPC1tEL8Te/ID8yg+Y7nGPUiOLfk9x5LKgDmb+OWb/AUbD3YL9AetRdIL7DkG9xhx4np5Le7aRzcuL+HFQk31Db8rJ322fipL+CbUToYzZfGHzH0aoPsMoZ0+vbOLIg6z0WHEiRA+7qDlUcBTmA9uKRyjx04XJeebX5HiDyPhY8xf4LhElWuD1VJmLOF6gSFbd+4v+LwybCMb9ZmEnXmMcLj16RF70f1MpAzgrDlFzbjcLX8G7rL4Vdu8XJOkR9fCmd3/TF+UE/0vZowQtEU/PE/MYCeIfnWagyK0LQtchV/jKFtZ8dr283xZQWM3mz8g83VXwq7clcWABwQECK66E2iv6Y6DVhSd20SPPxY7ZaQT35VQvvH+EedO47FNI712oTvT8AYbq5sMumufTlR9VcJArwDLVnnJ/Z7D3Z/mprCrnTRPpb7Dv19hmwEmYVle3rC4Z7/DRWy6GLw9RgazGwhWnkvmtatEWLibVeyizMxY/yqeevaAWE+P/0Zqz12IRWD3p912N8zYJ2OARXrQUxxqBlGh/8QQX4Q9RZKowivKMIsjsB7z7hnaeuvhWfYm3SAgtB0mScaz8agwP/COKpg8WKG0am7nk4/tm+TG08UafCLcL3Mq0GDBg0aNGjQoEGDBg0aNGjQoEGDBg0aNGjQ4D+N/wHgKAy8ZU/jLQAAAABJRU5ErkJggg=="
                  />
                  Chat With Us
                  <button
                    className="btn btn-primary"
                    style={{ float: "right" }}
                    onClick={() => setShowChat(false)}
                  >
                    -
                  </button>
                </div>
                <div className="chat-content">
                  <p>Hi My name is test</p>
                  <p>Hi I am here to assist you. How may I help you?</p>
                </div>
                <div className="chat-footer">
                  <div className="position-relative">
                    <input type="text" className="form-control" />
                    <button className="btn btn-danger">Send</button>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {/* <div className="right-side d-none d-none d-lg-none d-xl-flex">
                            <div className="header-widget">
                                <a href="#" className="button border">Add Listing<i className="fas fa-laptop-house ml-2"></i></a>
                            </div>
                        </div> */}

            {/* <div className="right-side d-none d-none d-lg-none d-xl-flex sign ml-0">
                            <div className="header-widget sign-in">
                                <div className="show-reg-form modal-open"><a href="#">Sign In</a></div>
                            </div>
                        </div>

                        <div className="header-user-menu user-menu add d-none d-lg-none d-xl-flex">
                            <div className="lang-wrap">
                                <div className="show-lang"><span><i className="fas fa-globe-americas"></i><strong>ENG</strong></span><i className="fa fa-caret-down arrlan"></i></div>
                                <ul className="lang-tooltip lang-action no-list-style">
                                    <li><a href="#" className="current-lan" data-lantext="En">English</a></li>
                                    <li><a href="#" data-lantext="Fr">Francais</a></li>
                                    <li><a href="#" data-lantext="Es">Espanol</a></li>
                                    <li><a href="#" data-lantext="De">Deutsch</a></li>
                                </ul>
                            </div>
                        </div> */}
          </div>
        </div>
      </header>
    </>
  );
};
export default Header;
